var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvaBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "#F5F3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.552 152C90.5408 152 90.5296 152 90.5183 152C90.5071 152 90.4959 152 90.4847 152C67.9271 151.989 47.8542 141.392 35 124.925C44.4885 115.202 64.645 106.772 90.5183 106.772C116.358 106.772 136.496 115.259 146 124.972C133.144 141.413 113.088 151.989 90.552 152Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5183 92.3537C107.641 92.5233 121.107 78.6144 121.107 60.38C121.107 43.2482 107.552 29 90.5183 29C73.3958 29 59.7512 43.2482 59.9296 60.38C60.0188 78.6144 73.3066 92.1841 90.5183 92.3537Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaBig);
export default __webpack_public_path__ + "static/media/avaBig.a61a77b6682b7c8a81140d1f08601358.svg";
export { ForwardRef as ReactComponent };